module.exports = __webpack_public_path__ + "img/eg-23-01.420a8ad3.jpg";